module.exports = __webpack_public_path__ + "static/media/act-00.6f26d58f.mp3";